import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useFavoritesContext } from "../../../state/FavoritesContext";
import { useSiteContext } from "../../../state/SiteContext";
import { getFavoritesKey, getFavorites } from "../../../state/favorites-storage";

/**
 * Array source that returns the list of favorites from localStorage for the current site.
 * Reads via SiteContext; calls setArray in useEffect (client-only).
 */
export const Favorites = React.memo(function Favorites(): React.ReactElement {
  const { setArray } = useArrayContext();
  const { siteState } = useSiteContext();
  const { favoritesVersion } = useFavoritesContext();

  useEffect(() => {
    const siteName = siteState.site?.name;
    if (!siteName) {
      setArray([]);
      return;
    }
    const key = getFavoritesKey(siteName);
    const items = getFavorites(key);
    setArray(items);
  }, [siteState.site?.name, setArray, favoritesVersion]);

  return <></>;
});
